import type { Todo, TodoDetail, TodoStatus, CreateTodoRequest, UpdateTodoRequest } from '../types/todo.js';

const TODOS_URL = '/api/todos';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getTodos(pseudoProjectId: number): Promise<Todo[]> {
  return fetchJson<Todo[]>(`${TODOS_URL}?pseudoProjectId=${pseudoProjectId}`);
}

export async function getTodo(id: number): Promise<TodoDetail> {
  return fetchJson<TodoDetail>(`${TODOS_URL}/${id}`);
}

export async function updateTodoStatus(id: number, status: TodoStatus): Promise<Todo> {
  return fetchJson<Todo>(`${TODOS_URL}/${id}/status`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status }),
  });
}

export async function createTodo(data: CreateTodoRequest): Promise<Todo> {
  return fetchJson<Todo>(TODOS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function updateTodo(id: number, data: UpdateTodoRequest): Promise<Todo> {
  return fetchJson<Todo>(`${TODOS_URL}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function deleteTodo(id: number): Promise<void> {
  const response = await fetch(`${TODOS_URL}/${id}`, { method: 'DELETE' });
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
}

export async function getSubTickets(parentTodoId: number): Promise<Todo[]> {
  const detail = await fetchJson<TodoDetail>(`${TODOS_URL}/${parentTodoId}`);
  return detail.sub_tickets ?? [];
}
